import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  Inject,
  PLATFORM_ID,
  AfterViewInit
} from '@angular/core';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-offers',
  template: `
    <div class="swiper" #swiperContainer *ngIf="slides.length > 0">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let s of slides">
          <a [href]="s.link || 'javascript:void(0)'">
            <img [src]="s.img" alt="offer banner" />
          </a>
        </div>
      </div>

      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  `,
  styleUrls: ['./offers.component.scss']
})
export class OffersComponent implements OnInit, AfterViewInit {
  @ViewChild('swiperContainer', { static: false }) swiperEl!: ElementRef;

  isMobile = false;
  isAr = false;
  contentReady = true;
  noData = false;

  swiper?: Swiper;
  private isBrowser: boolean;

  slides: any[] = [];

  constructor(
    private deviceService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;

    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') === 'ar';

    this.loadStaticSlides();
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) return;

    setTimeout(() => {
      if (this.slides.length > 0) {
        this.initSwiper();
      }
    });
  }

  loadStaticSlides(): void {
    this.slides = [
      {
        img: this.isMobile
          ? '/assets/staticbanner.mobile.png'
          : '/assets/staticbanner.png',
      },
    ];
  }

  private initSwiper(): void {
    if (!this.isBrowser || !this.swiperEl) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.swiperEl.nativeElement, {
      modules: [Navigation, Pagination, Autoplay],
      navigation: true,
      pagination: { clickable: true },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      loop: true,
      speed: 2000,
    });
  }
}
